import { useSelector } from 'react-redux';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import InpageDraggableSection from './InpageDraggableSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getThemelessSections } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import InpageSectionAccordion, { TitleWrapper } from './InpageSectionAccordion';
import { EMBED_LIMIT, getHasReachedEmbedLimit } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InpageThemelessSectionsContainer({
  onDragStart,
  onDragEnd
}) {
  const themelessSections = useSelector(getThemelessSections);
  const hasReachedEmbedLimit = useSelector(getHasReachedEmbedLimit);
  if (themelessSections.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(InpageSectionAccordion, {
    title: /*#__PURE__*/_jsx(TitleWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "addSectionPanel.customSections.noThemeSections",
        options: {
          count: themelessSections.length
        }
      })
    }),
    type: "EMBED",
    children: /*#__PURE__*/_jsx(CardGrid, {
      columns: 1,
      gutterSize: 10,
      marginBlockStart: "400",
      children: themelessSections.map(section => /*#__PURE__*/_jsx(InpageDraggableSection, {
        section: section,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        themePath: "",
        isDraggable: !hasReachedEmbedLimit,
        notAddableMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "inpage.layout.addSection.embedReachedLimit",
          options: {
            limit: I18n.formatNumber(EMBED_LIMIT)
          }
        })
      }, `${section.id}-${section.name}`))
    })
  });
}